import { render, staticRenderFns } from "./SettingsPanelPayment.vue?vue&type=template&id=ff68af8e&scoped=true"
import script from "./SettingsPanelPayment.vue?vue&type=script&lang=js"
export * from "./SettingsPanelPayment.vue?vue&type=script&lang=js"
import style0 from "./SettingsPanelPayment.vue?vue&type=style&index=0&id=ff68af8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff68af8e",
  null
  
)

export default component.exports